<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="calendar2-event" class="icon"></b-icon>
            <span>ปฏิทินงาน</span>
        </div>

        <div class="content">
            <div class="text-center mb-4">
                <button class="btn btn-main" @click="openBookingForm(null)">เพิ่มวันนัดหมาย</button>
            </div>

            <div class="calendar">
                <div class="header">
                    <div class="row">
                        <div class="col-3 text-left">
                            <button class="arrow" @click="goPrevMonth()">
                                <b-icon icon="chevron-left"></b-icon>
                            </button>
                        </div>
                        <div class="col-6 text-center">
                            <span class="month">{{ month }} {{ year }}</span>
                        </div>
                        <div class="col-3 text-right">
                            <button class="arrow" @click="goNextMonth()">
                                <b-icon icon="chevron-right"></b-icon>
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="weekdays">
                    <div class="weekday" v-for="(day, index) in days" :key="index">
                        {{ day }}
                    </div>
                </div>

                <div class="dates">
                    <div class="date text-right" :class="{ 'no-border-right': date.key % 7 === 0, 'no-show-mobile': date.moment.get('month') !== dateContext.get('month') }" v-for="date in dateRenderList" :key="date.key" :data-date="date.date">
                        <div class="wrapper" :class="{ 'blank': date.blank, 'today': date.today }">
                            <span class="day">{{ date.dayNumber }} <span>{{ days[date.key % 7] }}</span></span>
                            <span class="weekday">{{ date.weekDay }}</span>
                            <button class="btn-appointment" @click="openBookingForm(new Date(date.moment))"><b-icon icon="calendar2-plus"></b-icon></button>

                            <div class="events" @click="openAppointmentList(date.appointment)" v-if="date.appointment.service + date.appointment.other > 0">
                                <div class="item" v-if="date.appointment.service > 0">
                                    <label>นัดบริการ</label>
                                    <div class="number">
                                        <span>{{ date.appointment.service }}</span>
                                    </div>
                                </div>
                                <div class="item" v-if="date.appointment.other > 0">
                                    <label>นัดอื่นๆ</label>
                                    <div class="number">
                                        <span>{{ date.appointment.other }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-booking-form :isDisplay="isShowBookingForm" :bookingDate="selectedBookingDate" @hide="closeBookingForm($event)"></job-modal-booking-form>
        <job-modal-appointment-list :isDisplay="isShowAppointmentList" :appointmentData="selectedAppointmentDate" @hide="closeAppointmentList($event)"></job-modal-appointment-list>
    </div>
</template>

<script>
import moment from 'moment';
import JobModalBookingForm from '@/components/job/schedule/ModalBookingForm';
import JobModalAppointmentList from '@/components/job/schedule/ModalAppointmentList';
import DBBooking from '@/database/Booking';

export default {
    components: {
        JobModalBookingForm,
        JobModalAppointmentList
    },
    data() {
        return {
            isShowBookingForm: false,
            isShowAppointmentList: false,
            selectedBookingDate: null,
            selectedAppointmentDate: null,
            today: moment(),
            dateContext: moment(),
            days: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
            dateRenderList: []
        }
    },
    async mounted() {
        await this.loadBookingData();

        this.dateRenderList = this.generateCalendar();
    },
    computed: {
        year() {
            return this.dateContext.format('Y');
        },
        month() {
            return this.dateContext.format('MMMM');
        },
        daysInMonth() {
            return this.dateContext.daysInMonth();
        },
        currentDate() {
            return this.dateContext.get('date');
        },
        firstDayOfMonth() {
            let firstDay = moment(this.dateContext).subtract(this.currentDate,'days');

            return firstDay.weekday();
        },
        previousMonth() {
            return moment(this.dateContext).subtract(1, 'month');
        },
        previousMonthAsString() {
            return this.previousMonth.format('MMMM');
        },
        nextMonth() {
            return moment(this.dateContext).add(1, 'month');
        },
        nextMonthAsString() {
            return this.nextMonth.format('MMMM');
        },

        daysInPreviousMonth() {
            return this.previousMonth.daysInMonth();
        },
        daysFromPreviousMonth() {
            let daysList = [];
            let count = this.daysInPreviousMonth - this.firstDayOfMonth;

            while (count < this.daysInPreviousMonth) {
                count++;
                daysList[count] = count;
            }

            return daysList.filter(function() {
                return true;
            });
        },
        initialDate() {
            return this.formattingDay(this.today.get('date'));
        },
        initialMonth() {
            return this.today.format('MMMM');
        },
        initialYear() {
            return this.today.format('Y');
        },
        todayInCurrentMonthAndYear() {
            return (
                this.month === this.initialMonth &&
                this.year === this.initialYear
            );
        }
    },
    methods: {
        generateCalendar() {
            const dateList = [];
            const previousMonth = this.previousMonth;
            const nextMonth = this.nextMonth;

            //dates for display
            const formattedCurrentMonth = this.dateContext.format('MM');
            const formattedCurrentYear = this.year;
            const formattedPreviousMonth = previousMonth.format('MM');
            const formattedPreviousYear = previousMonth.format('Y');
            const formattedNextMonth = nextMonth.format('MM');
            const formattedNextYear = nextMonth.format('Y');

            //counters
            let countDayInCurrentMonth = 0;
            let countDayInPreviousMonth = 0;

            //filling in dates from the previous month
            this.daysFromPreviousMonth.forEach((dayFromPreviousMonth) => {
                countDayInCurrentMonth++;
                countDayInPreviousMonth++;

                const formattedDay = this.formattingDay(dayFromPreviousMonth);

                dateList[countDayInCurrentMonth] = this.generateDateList(countDayInCurrentMonth, 
                                                                        formattedDay,
                                                                        formattedPreviousMonth,
                                                                        formattedPreviousYear,
                                                                        null,
                                                                        false);
            });

            //filling in dates from the current month
            while (countDayInCurrentMonth < this.firstDayOfMonth + this.daysInMonth) {
                countDayInCurrentMonth++;

                const day = countDayInCurrentMonth - countDayInPreviousMonth;
                const weekDay = this.getWeekDay(countDayInCurrentMonth);
                const formattedDay = this.formattingDay(day);

                dateList[countDayInCurrentMonth] = this.generateDateList(countDayInCurrentMonth, 
                                                                        formattedDay,
                                                                        formattedCurrentMonth,
                                                                        formattedCurrentYear,
                                                                        weekDay,
                                                                        true);
            }

            let daysInNextMonth = 7 - (countDayInCurrentMonth % 7);
            let countDayInCurrentMonthSaved = countDayInCurrentMonth;
            let day = 0;

            //filling in dates from the next month
            if (daysInNextMonth < 7) {
                while (countDayInCurrentMonth < countDayInCurrentMonthSaved + daysInNextMonth) {
                    countDayInCurrentMonth++;
                    day++;

                    const formattedDay = this.formattingDay(day);

                    dateList[countDayInCurrentMonth] = this.generateDateList(countDayInCurrentMonth, 
                                                                        formattedDay,
                                                                        formattedNextMonth,
                                                                        formattedNextYear,
                                                                        null,
                                                                        false);
                }
            }

            return dateList.filter(() => {
                return true;
            });
        },
        generateDateList(countDay, formattedDay, formattedMonth, formattedYear, weekDay, isSelectedMonth) {
            return {
                key: countDay,
                dayNumber: formattedDay,
                date:
                    formattedDay +
                    '.' +
                    formattedMonth +
                    '.' +
                    formattedYear,
                blank: isSelectedMonth ? false : true,
                today: formattedDay === this.initialDate && this.todayInCurrentMonthAndYear,
                weekDay: isSelectedMonth ? weekDay : false,
                moment: moment(
                    formattedYear +
                    formattedMonth +
                    formattedDay
                ),
                appointment: this.getAppointmentData(new Date(formattedYear, formattedMonth - 1, formattedDay))
            };
        },
        openBookingForm(date) {
            this.selectedBookingDate = date;
            this.isShowBookingForm = true;
        },
        async closeBookingForm(isReload) {
            this.isShowBookingForm = false;

            if (isReload) {
                await this.loadBookingData();
        
                this.dateRenderList = this.generateCalendar();
            }
        },
        openAppointmentList(item) {
            this.selectedAppointmentDate = item;

            this.isShowAppointmentList = true;
        },
        async closeAppointmentList(isReload) {
            this.isShowAppointmentList = false;
            
            if (isReload) {
                await this.loadBookingData();
        
                this.dateRenderList = this.generateCalendar();
            }
        },
        goNextMonth() {
            this.dateContext = this.nextMonth;
        },
        goPrevMonth() {
            this.dateContext = this.previousMonth;
        },
        formattingDay(day) {
            return ('0' + day).slice(-2);
        },
        getWeekDay(day) {
            let index = day;

            if (index > 7) {
                index %= 7;
            }

            index = index === 0 ? 6 : index - 1;

            return this.days[index];
        },
        async loadBookingData() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            this.bookingList = [];
            const result = await DBBooking.get();

            if (result.content && result.content.length > 0) {
                this.bookingList = result.content;
            }

            loader.hide();
        },
        getAppointmentData(date) {
            const booking = this.bookingList.find(x => this.getTimeWithTimeZone(new Date(x.keyDate)) === date.getTime());
            const appointment = {
                keyDate: '',
                service: 0,
                other: 0,
                list: []
            };

            if (booking) {
                appointment.keyDate = booking.keyDate;
                appointment.service = booking.appointment.filter(x => x.reserve.bookingId).length;
                appointment.other = booking.appointment.filter(x => !x.reserve.bookingId).length;
                appointment.list = booking.appointment;

                return appointment;
            }

            return appointment;
        },
        getTimeWithTimeZone(date) {
            return date.setHours(0, 0, 0, 0);
        }
    }
}
</script>